import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Utils, fetchWithAuth, getDefaultPageSize, getTotalPages, can, exportListCsv } from '../../utils';
import { useParams } from 'react-router-dom';
import SubscriptionFiltersBar from '../users/SubscriptionFiltersBar';
import { EMPTY_SUBSCRIPTION_LIST_FILTERS, buildSubscriptionListBody, filtersObjectHasAnyValue, getBrowserTimeZone } from '../../utils';
import { Collapse } from 'react-bootstrap';
import { RxCross2 } from "react-icons/rx";
import { MdKeyboardArrowDown, MdFileDownload } from 'react-icons/md';
import { FiRefreshCw } from 'react-icons/fi';
import { toast } from 'react-toastify';
import SkeletonLoader from "../common/SkeletonLoader";
import { useActionDropdown } from "../../hooks/useActionDropdown";
import { useTableMaxHeight } from "../../hooks/useTableMaxHeight";
import { useScrollEndDetection } from "../../hooks/useScrollEndDetection";
import ListPaginationBar from "../common/ListPaginationBar";

const TestSubscription = () => {

    const { appId } = useParams()
    const [appUsers, setAppUsers] = useState([])
    const tableScrollRef = useRef(null);
    const tableInnerRef = useRef(null);

    const [noDataFound, setNoDataFound] = useState(false) // eslint-disable-line no-unused-vars
    const [isLoading, setIsLoading] = useState(true)
    const [isExporting, setIsExporting] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = getDefaultPageSize();
    const [usersTotal, setUsersTotal] = useState(0);
    const [draftFilters, setDraftFilters] = useState(() => ({ ...EMPTY_SUBSCRIPTION_LIST_FILTERS }));
    const [appliedFilters, setAppliedFilters] = useState(() => ({ ...EMPTY_SUBSCRIPTION_LIST_FILTERS }));
    const [deviceTypeOptions, setDeviceTypeOptions] = useState([]);
    const [filterAccordionOpen, setFilterAccordionOpen] = useState(false);

    useEffect(() => {
        const hasContent =
            filtersObjectHasAnyValue(draftFilters) || filtersObjectHasAnyValue(appliedFilters);
        if (!hasContent) {
            setFilterAccordionOpen(false);
            return;
        }
        setFilterAccordionOpen(true);
    }, [draftFilters, appliedFilters]);

    const { openActionItem, dropdownPosition, dropdownRef, closeDropdown, handleOpenDropdown } = useActionDropdown({
      tableScrollRef,
      optionCount: () => (can("test_subscriptions.delete") ? 1 : 0),
      menuWidth: 200,
    });
    const tableMaxHeight = useTableMaxHeight(tableScrollRef);
    const isAtScrollEnd = useScrollEndDetection(tableScrollRef, tableInnerRef, appUsers?.length);

    function getAppUser() {
        fetchWithAuth(Utils.baseurl + 'get/app/subscriptions', {
            method: 'POST',
            body: JSON.stringify({
                id: appId,
                isTest: 1,
                ...buildSubscriptionListBody(appliedFilters),
                page: currentPage,
                pageSize,
                timezone: getBrowserTimeZone() || undefined,
            }),
        })
            .then((response) => response.json())
            .then(async (result) => {
                if (result.status) {
                    setAppUsers(result.data.appSubscriptionData || []);
                    setUsersTotal(result.data.meta?.total ?? (result.data.appSubscriptionData?.length || 0));
                    setIsLoading(false);
                    if (!(result.data.appSubscriptionData || []).length) {
                        setNoDataFound(true);
                    } else {
                        setNoDataFound(false);
                    }
                }
            })
            .catch((error) => console.error(error));
    }

    useEffect(() => {
        fetchWithAuth(Utils.baseurl + 'get/app/sub-device-os', {
            method: 'POST',
            body: JSON.stringify({ id: appId }),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.status && Array.isArray(result.data?.deviceTypes)) {
                    setDeviceTypeOptions(result.data.deviceTypes);
                }
            })
            .catch(() => { });
    }, [appId]);

    useLayoutEffect(() => {
        setDraftFilters({ ...EMPTY_SUBSCRIPTION_LIST_FILTERS });
        setAppliedFilters({ ...EMPTY_SUBSCRIPTION_LIST_FILTERS });
        setCurrentPage(1);
    }, [appId]);

    useEffect(() => {
        setIsLoading(true);
        getAppUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, appliedFilters, appId]);

    const handleApplyFilters = () => {
        setAppliedFilters({ ...draftFilters });
        setCurrentPage(1);
    };

    const handleResetFilters = () => {
        const cleared = { ...EMPTY_SUBSCRIPTION_LIST_FILTERS };
        setDraftFilters(cleared);
        setAppliedFilters(cleared);
        setCurrentPage(1);
    };

    const totalRows = usersTotal || 0;
    const totalPages = getTotalPages(totalRows, pageSize);
    const safePage = Math.min(Math.max(1, currentPage), totalPages);


    function handleAction(type, id) {

        if (type === "Delete") {
            fetchWithAuth(Utils.baseurl + 'update/app/users', {
                method: 'POST',
                body: JSON.stringify({ id: id, isTest: 0 }),
            })
                .then((response) => response.json())
                .then(async (result) => {
                    if (result.status) {
                        getAppUser()

                    }
                })
                .catch((error) => console.error(error));
        }

        if (type === "addtest") {
            // navigate(`/apps/${id}`)
        }

    }


    let loaderData = [
        {
            id: 1,
            name: 'test',
        },
        {
            id: 1,
            name: 'test',
        },
        {
            id: 1,
            name: 'test',
        },
        {
            id: 1,
            name: 'test',
        },
        {
            id: 1,
            name: 'test',
        },
        {
            id: 1,
            name: 'test',
        },
        {
            id: 1,
            name: 'test',
        },
        {
            id: 1,
            name: 'test',
        },
        {
            id: 1,
            name: 'test',
        },
        {
            id: 1,
            name: 'test',
        }
    ]

    const handleExport = async () => {
        if (isExporting) return;
        setIsExporting(true);
        try {
            const { status, message } = await exportListCsv("get/app/subscriptions", {
                id: appId,
                isTest: 1,
                ...buildSubscriptionListBody(appliedFilters),
                timezone: getBrowserTimeZone() || undefined,
            }, "test-subscription-records.csv");
            if (!status) {
                toast.error(message);
                return;
            }
            if (message) toast.info(message);
        } catch (error) {
            console.error(error);
            toast.error("Export failed");
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <div className="dashboard_right">
            <div className="dashboard_inner">
                <div className="dashboard_right_top">
                    <div className="dashboard_heading">
                        <h1>Test Subscription Records</h1>
                    </div>
                    <div className="add_app" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <button type="button" className="add_app_btn_secondary btn_theme_secondary" title="Refresh list" onClick={() => { setIsLoading(true); getAppUser(); }}>
                            <FiRefreshCw />
                            <span>Refresh</span>
                        </button>
                        <button type="button" className="add_app_btn_secondary btn_theme_secondary" title="Export CSV for applied filters" onClick={handleExport} disabled={isExporting}>
                            <MdFileDownload />
                            <span>{isExporting ? 'Exporting…' : 'Export'}</span>
                        </button>
                    </div>
                </div>
                <div className="list-page-filter-card">
                    <button
                        type="button"
                        className="list-page-filter-accordion-header"
                        onClick={() => setFilterAccordionOpen((o) => !o)}
                        aria-expanded={filterAccordionOpen}
                        aria-controls="test-sub-filter-panel"
                        id="test-sub-filter-accordion"
                    >
                        <span className="list-page-filter-accordion-title">Filter</span>
                        <MdKeyboardArrowDown
                            className={`list-page-filter-accordion-chevron ${filterAccordionOpen ? 'list-page-filter-accordion-chevron--open' : ''}`}
                            size={22}
                            aria-hidden
                        />
                    </button>
                    <Collapse in={filterAccordionOpen}>
                        <div
                            className="list-page-filter-accordion-body"
                            id="test-sub-filter-panel"
                            role="region"
                            aria-labelledby="test-sub-filter-accordion"
                        >
                            <SubscriptionFiltersBar
                                draftFilters={draftFilters}
                                setDraftFilters={setDraftFilters}
                                onSearch={handleApplyFilters}
                                onReset={handleResetFilters}
                                deviceTypeOptions={deviceTypeOptions}
                                includeNameField
                                instanceIdPrefix="test-sub"
                            />
                        </div>
                    </Collapse>
                </div>
                <div className="dashboard_app_table dashboard_app_table--list-records table-responsive">
                    <div className="dashboard_table">
                        <div
                            ref={tableScrollRef}
                            className="table_scroll_wrapper"
                        >
                            <div
                                ref={tableInnerRef}
                                className={`table_inner table_y_scroll ${isAtScrollEnd ? 'at-scroll-end' : ''}`}
                                style={{
                                    maxHeight: tableMaxHeight ? `${tableMaxHeight}px` : 'calc(100vh - 320px)',
                                    overflowY: 'auto',
                                    overflowX: 'auto',
                                }}
                            >
                                <table className="table_outer table-sm">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th style={{ textAlign: "center" }}>SubscriptionId</th>
                                            <th style={{ textAlign: "center" }}>Notify Sphere Id</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Device Name</th>
                                            <th>Device</th>
                                            <th style={{ textAlign: "center" }}>Token</th>
                                            <th style={{ textAlign: "center" }}>Latitude</th>
                                            <th style={{ textAlign: "center" }}>Longitude</th>
                                            <th style={{ textAlign: "center" }}>Status</th>
                                            <th className="col-action" style={{ textAlign: "center" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {appUsers.length === 0 ? (
                                            <tr>
                                                <td colSpan="10" style={{ textAlign: "center" }}>
                                                    {
                                                        isLoading ?
                                                            // <FontAwesomeIcon icon={faSpinner} style={{ marginTop: "10px" }} spin size="2x" />
                                                            <SkeletonLoader columns={loaderData} rows={2} />
                                                            : <p  >No data found</p>
                                                    }
                                                </td>
                                            </tr>
                                        ) : appUsers.map(item => (
                                            <tr key={item.id}>
                                                <td>
                                                    <span style={{ font: 'inherit', color: 'inherit' }}>
                                                        {item.name}
                                                    </span>
                                                </td>
                                                <td style={{ textAlign: "center" }}><span>{item.subscription_id}</span> </td>
                                                <td style={{ textAlign: "center" }}><span>{item.app_user?.notify_sphere_id ?? '—'}</span> </td>
                                                <td className="col-email"><span title={item.app_user?.email}>{item.app_user?.email ?? '—'}</span></td>
                                                <td className="col-phone"><span title={item.app_user?.phone}>{item.app_user?.phone ?? '—'}</span></td>
                                                <td>
                                                    <span style={{ font: 'inherit', color: 'inherit' }}>
                                                        {item.device_model}
                                                    </span>
                                                </td>
                                                <td style={{ textAlign: "center" }}><span title={[item.device_os, item.device_version].filter(Boolean).join(' / ')}>{item.device_os}</span> </td>
                                                <td style={{ textAlign: "center" }}><span>{item.token ? `${item.token.slice(0, 30)}...` : '—'}</span></td>
                                                <td style={{ textAlign: "center" }}>{item.app_user?.lat ?? '—'}</td>
                                                <td style={{ textAlign: "center" }}>{item.app_user?.long ?? '—'}</td>
                                                <td style={{ textAlign: "center" }}><span>0</span> </td>
                                                <td className="col-action" style={{ textAlign: "center" }}>
                                                    <button type="button" className="dropdown-trigger-btn" onClick={(e) => handleOpenDropdown(e, item.id, item)}>
                                                        <svg viewBox="0 0 16 16" fill="currentColor">
                                                            <path d="M8 5.25A1.625 1.625 0 108 2a1.625 1.625 0 000 3.25zM8 9.625a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25zM9.625 12.375a1.625 1.625 0 11-3.25 0 1.625 1.625 0 013.25 0z" fill="currentColor">
                                                            </path>
                                                        </svg>
                                                    </button>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <ListPaginationBar
                                page={safePage}
                                setPage={setCurrentPage}
                                total={totalRows}
                                pageSize={pageSize}
                                totalPages={totalPages}
                                ariaLabel="Test subscriptions pagination"
                                loading={isLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {openActionItem && dropdownPosition && createPortal(
                <div ref={dropdownRef} style={{ position: 'fixed', left: dropdownPosition.left, top: dropdownPosition.top, zIndex: 10000, minWidth: '220px' }}>
                    <div className="dropdown-menu-subscription">
                        {can("test_subscriptions.delete") ? (
                        <button
                            className="delete-class"
                            onClick={() => { closeDropdown(); handleAction('Delete', openActionItem.id); }}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', textAlign: 'left', color: 'red' }}
                        >
                            <RxCross2 size={18} style={{ marginRight: '8px', flexShrink: 0 }} />
                            <span style={{ fontSize: '0.875rem' }}>Delete</span>
                        </button>
                        ) : null}
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};

export default TestSubscription;
